module.exports = __webpack_public_path__ + "img/20-3-bg.ef672031.png";